import { render } from "./FullLinesField2.vue?vue&type=template&id=d77a0996"
import script from "./FullLinesField2.vue?vue&type=script&lang=js"
export * from "./FullLinesField2.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__